import { cEl } from '../../../util';
import gausiumEcobotVacuum40 from '../../../assets/images/learn/gausium-ecobot-vacuum40.png';
import gausiumEcobotVacuum50 from '../../../assets/images/learn/gausium-ecobot-vacuum50.png';

function Clean() {
    const article = cEl('article');
    article.classList.add('delivery', 'learn-section');

    const contents = cEl('div');
    contents.innerHTML = `
    <div class="learn-header">
        <h2>병원 서비스 로봇의 종류 3 : <span class="color-brand">청소/방역 로봇</span></h2>
    </div>
    <div class="learn-page">
        <div class="gray-box">
            <h2>청소/방역 로봇</h2>
            <div class="img-container">
                <div class="img-wrapper border-radius">
                    <img src="${gausiumEcobotVacuum40}" alt="가우시움 Ecobot Vacuum 40">
                    <span>가우시움 Ecobot Vacuum 40</span>
                </div>
                <div class="img-wrapper border-radius">
                    <img src="${gausiumEcobotVacuum50}" alt="가우시움 Ecobot Vacuum 50">
                    <span>가우시움 Ecobot Vacuum 50</span>
                </div>
            </div>
            <div class="description-container">
                <div class="description-wrapper" style="flex: 0 0 480px">
                    <div class="description-topic">사용처</div>
                    <ul class="description-list">
                        <li>(청소로봇) 넓은 영역의 진공 및 물청소 가능</li>
                        <li>(방역로봇) 헤파필터, 램프 사용 세균 및 바이러스 억제 가능</li>
                    </ul>
                </div>
                <div class="description-wrapper" style="flex: 0 0 480px">
                    <div class="description-topic">주의점</div>
                    <ul class="description-list">
                        <li>(방역로봇) 방역의 효과성 입증되지 않음</li>
                        <li>(방역로봇) 의료진의 추가 방역 필요하여 비추천</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    `;

    const buttonWrapper = cEl('div');
    buttonWrapper.classList.add('button-wrapper');

    const moreButton = cEl('button');
    moreButton.classList.add('button', 'border-button');
    moreButton.innerHTML = '다양한 청소/방역 로봇 둘러보기';
    moreButton.addEventListener('click', e => {
        window.open('https://www.myrobotsolution.com/store/service?categoryId=25&categoryId=26', '_blank');
    });
    buttonWrapper.appendChild(moreButton);

    contents.append(buttonWrapper);

    article.appendChild(contents);

    return article;
}

export default Clean;
